//中医报告
export const GET_CHINESE_MEDICINE_REPORT = "get_chinese_medicine_report";
export const REQ_CHINESE_MEDICINE_REPORT = "req_chinese_medicine_report";
//中医健康趋势图
export const GET_CHINESE_MEDICINE_DATA = "get_chinese_medicine_data";
export const REQ_CHINESE_MEDICINE_DATA = "req_chinese_medicine_data";
